import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const RootRedirect = () => {
  const { user, token } = useAuth();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Admin user → dashboard
  if (!user.vertical_key) {
    return <Navigate to="/dashboard" replace />;
  }

  // Normal user → own vertical inquiries
  return <Navigate to={`/${user.vertical_key}/inquiries`} replace />;
};

export default RootRedirect;
